import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminSubpage from '../components/AdminSubpage';
import { colorsAPI } from '../services/api';

const emptyForm = { name: '', name_ar: '', hex_code: '' };

const ColorFormPage = () => {
  const { colorId } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(colorId);
  const [formData, setFormData] = useState(emptyForm);
  const [loading, setLoading] = useState(isEdit);

  useEffect(() => {
    if (!isEdit) {
      setFormData(emptyForm);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const response = await colorsAPI.getAll();
        const colorsData =
          response.data?.colors || (Array.isArray(response.data) ? response.data : []);
        const color = colorsData.find((c) => String(c.id) === String(colorId));
        if (!cancelled) {
          if (color) {
            setFormData({
              name: color.name || '',
              name_ar: color.name_ar || '',
              hex_code: color.hex_code || '',
            });
          } else {
            toast.error('Color not found');
          }
        }
      } catch (error) {
        if (!cancelled) toast.error(error.response?.data?.message || error.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [colorId, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name?.trim()) {
      toast.error('Color name is required!');
      return;
    }

    try {
      if (isEdit) {
        await colorsAPI.update(colorId, formData);
        toast.success('Color updated successfully!');
      } else {
        await colorsAPI.create(formData);
        toast.success('Color created successfully!');
      }
      navigate('/colors');
    } catch (error) {
      const action = isEdit ? 'updating' : 'creating';
      let errorMessage = `Error ${action} color: `;
      if (error.response?.data?.errors) {
        errorMessage += Object.values(error.response.data.errors).flat().join('\n');
      } else if (error.response?.data?.message) {
        errorMessage += error.response.data.message;
      } else {
        errorMessage += error.message || 'Unknown error';
      }
      toast.error(errorMessage);
    }
  };

  const title = isEdit ? 'Edit color' : 'Add color';

  return (
    <AdminSubpage title={title} backTo="/colors">
      {loading ? (
        <div className="loading">Loading…</div>
      ) : (
        <div className="admin-page-panel modal-content">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label>Name (Arabic)</label>
              <input
                type="text"
                value={formData.name_ar}
                onChange={(e) => setFormData({ ...formData, name_ar: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Hex Code</label>
              <input
                type="text"
                value={formData.hex_code}
                onChange={(e) => setFormData({ ...formData, hex_code: e.target.value })}
                placeholder="#RRGGBB"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {isEdit ? 'Update Color' : 'Create Color'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => navigate('/colors')}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </AdminSubpage>
  );
};

export default ColorFormPage;
